<div class="page" id="page_agenda">
    <div class="container">

        <h2 class="section-title">AGENDA</h2>
        <!-- <p>
            Selectione um dia da semana<br/>
            para recarregar os horários
        </p> -->
        <p>
            Mantemos um número de membros <br/>
            reduzido para preservar a experiência <br/>
            NF Performance Club. <br/>
        </p>
<!-- 
        <div class="section-divider"></div>

        <br/><br/> -->

        <div style="display: none;">
            <div id="frmsearch" class="frm" style="min-height: 34px;">
                <input #search_dateto class="inputtxt" type="text"  
                    data-placeholder="Dia" required aria-required="true"
                    name="dateto" placeholder="Dia" list="search_days" 
                    value="{{ model_search_day }}"
                    (change)="select_change('searchday', search_dateto.value)"
                    (focus)="search_dateto.value='';"
                    (click)="search_dateto.value='';" />
                <datalist id="search_days">
                    @for(d of model_base_days; track d.toString()) {
                        <option [value]="d">{{d}}</option>
                    }
                    <!-- <option *ngFor="let d of model_base_days" [value]="d">{{d}}</option> -->
                </datalist>
            </div>

            <div class="window">
                @if (model_classes.length <= 0) {
                    <div class="empty"><br/><br/><br/>
                        <p style="text-align: center;color: #ccc;">Nenhum registro encontrado</p>
                    </div>
                }
                @else {
                    <ul style="padding-bottom: 90px;opacity: 1;">
                        @for(skill of model_base_skills; track skill) {
                            <li id="phome-liclassbox" class="content box alivebg"  
                                style="opacity: 1;padding: 0;margin: 9px 0; top: 0;float: left;padding-left: 41.2%;" >
                                @if (model_search_day.length > 0) {
                                <div>
                                    <!-- <img class="boxicon" 
                                        style="width: 34px;top: 9px; left:18px; position: absolute;"
                                            src="{{ '../assets/img/categs/' + skill + '.png' }}" /> -->
                                    <h4>{{skill}}</h4>
                                    <div>
                                        @for(reg of filterClasses(skill, search_dateto.value); track reg.id) {
                                            <div id="planbox{{ reg.id }}" class="alertbox" 
                                                style="position: relative;padding: 0">
                                            <!-- <h4 style="font-weight: 600; padding: 18px 0 9px 0;display: inline-block; float: left;">
                                                {{ reg.skill }}</h4> -->
                                            <p style="line-height: 25px;">
                                                <!-- {{ reg.day  }}  -->
                                                <b>{{ reg.time  }}</b></p>

                                            </div>
                                        }
                                    </div>
                                </div>
                                }
                            </li>
                        }
                        <li style="height: 90px;float: left; width: 90%;"></li>
                    </ul>
                }
            </div>

        </div>

        <div class="section-divider"></div>

        <div class="page-footer">
            <h4>AGENDE UMA AULA EXPERIMENTAL</h4>
            
            <a class="btn primary-line" 
                target="_blank"  
                href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                (click)="navigate('joinus')">
                <span>AGENDAMENTOS </span>
                <fa-icon [icon]="faWhatsapp" />
            </a>
        </div>

        <div class="section-divider"></div>

    </div>
</div>